import { Injectable } from '@angular/core';
import { PageLayoutService, ViewModes } from '@spartacus/storefront';
import { BehaviorSubject, Observable, map, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FacetSortService {
  currentViewMode$ = new BehaviorSubject<ViewModes>(ViewModes.Grid);
  viewModeByTemplate$: Observable<ViewModes> = this.pageLayoutService.templateName$.pipe(
    take(1),
    map(template => (template === 'ProductGridPageTemplate' ? ViewModes.Grid : ViewModes.List)),
  );

  constructor(private pageLayoutService: PageLayoutService) {}
}
